import React from 'react'

import styled from 'styled-components'

import { palette } from '_styles/variables'

const StyledText = styled.h2`
  font-size: 3.5rem;
  line-height: 1.5;
  text-align: center;
  color: ${palette.neutral['grey-ebebeb']};
`

export const renderEmptystate = () => (
  <StyledText>Sorry, we couldn&apos;t find any results</StyledText>
)
